module.exports = __webpack_public_path__ + "static/media/CompassHoldingLogo.3b20d2c6.png";